import React, { Component } from "react";
import { chakra, Box, Flex, Spinner } from "@chakra-ui/react";
import Presence from "src/constants/presence";
import NoiseIndicator from "src/modules/station/components/NoiseIndicator";
import { withFrame } from "src/components/Frame/Context";
import FullScreen from "src/atoms/FullScreen";
import Settings from "../../components/Settings";
import ControllingPanel from "../../components/ControllingPanel";
import MonitoringStatus from "../../components/MonitoringStatus";
import MotionButton from "../../components/MotionButton";
import NoCameraMode from "./NoCameraMode";
import SeeMeMode from "./SeeMeMode";

const EnhancedVideo = chakra("video");

class Monitor extends Component {
  state = {
    renderSettings: false,
    renderCameraList: false,
    renderMotionSensitivitySettings: false
  };

  videoRef = (window.videoRef = React.createRef());
  remoteVideoRef = React.createRef();
  componentDidMount = () => {
    this.setVideoStream();
    this.updateFrame();
  };

  componentDidUpdate(nextProps, nextState) {
    this.setVideoStream();
    this.updateFrame();
  }

  componentWillUnmount() {
    const { frame } = this.props;
    frame && frame.setDefaults();
  }

  setVideoStream() {
    const { localVideoStream } = this.props;
    if (!this.videoRef.current) return;
    if (
      this.videoRef.current.srcObject === null ||
      this.videoRef.current.srcObject !== localVideoStream
    ) {
      this.videoRef.current.srcObject = localVideoStream;
    }
  }

  updateFrame = () => {
    const { frame, remoteVideoStream } = this.props;

    frame &&
      frame.update({
        content: remoteVideoStream ? null : this.renderControllingPanel(),
        containerCss: {
          position: "absolute",
          top: "0px",
          left: "0px",
          bg: "rgba(0,0,0,0.2)"
        }
      });
  };
  renderControllingPanel = () => {
    const {
      presence,
      onAvatarChange,
      stopBroadcasting,
      cameraList,
      handleCameraChange,
      selectedCameraId,
      isMonitoring
    } = this.props;
    const isConnected = presence === Presence.SENDER_CONNECTED;

    const { renderCameraList } = this.state;
    return (
      <ControllingPanel
        isConnected={isConnected || isMonitoring}
        onAvatarChange={onAvatarChange}
        openSettings={this.openSettings}
        stopBroadcasting={stopBroadcasting}
        openCameraList={this.openCameraList}
        closeCameraList={this.closeCameraList}
        renderCameraList={renderCameraList}
        cameraList={cameraList}
        handleCameraChange={handleCameraChange}
        selectedCameraId={selectedCameraId}
      />
    );
  };

  openSettings = () => this.setState({ renderSettings: true });
  closeSettings = () => this.setState({ renderSettings: false });

  openCameraList = () => this.setState({ renderCameraList: true });
  closeCameraList = () => this.setState({ renderCameraList: false });

  toggleMotionSettings = () => {
    this.setState(({ renderMotionSensitivitySettings }) => ({
      renderMotionSensitivitySettings: !renderMotionSensitivitySettings
    }));
    this.closeSettings();
  };

  render() {
    const { renderSettings, renderMotionSensitivitySettings } = this.state;
    const {
      remoteVideoStream,
      stopVideoReceiving,
      noiseMeter,
      presence,
      hasCamera,
      monitoringStartTime,
      hasCameraPermission,
      frame,
      status,
      activity,
      motionSensitivity,
      indicateMotion,
      canDetectMotion,
      isMonitoring,
      openStartScheduledMonitoringDialog,
      scheduler
    } = this.props;
    const isConnected = presence === Presence.SENDER_CONNECTED;

    return (
      <>
        <Settings
          toggleMotionSettings={this.toggleMotionSettings}
          renderMotionSensitivitySettings={renderMotionSensitivitySettings}
          isConnected={isConnected || isMonitoring}
          isOpen={renderSettings}
          onClose={this.closeSettings}
          scheduler={scheduler}
          openStartScheduledMonitoringDialog={
            openStartScheduledMonitoringDialog
          }
        />
        <Box
          width="100vw"
          position="absolute"
          top="0"
          left="0"
          height="72px"
          backgroundImage="linear-gradient(rgba(0, 0, 0, 0.3),rgba(0, 0, 0, 0))"
        />
        <FullScreen ignoreFrame>
          {status === "starting" && (
            <Box
              transform="translateX(-50%)"
              position="absolute"
              top="50%"
              left="50%"
            >
              <Spinner size="lg" />
            </Box>
          )}
          {status === "starting" || hasCamera ? (
            <EnhancedVideo
              ref={this.videoRef}
              width="100%"
              height="100%"
              background="black"
              objectFit="cover"
              transform="scaleX(-1)"
              autoPlay
              muted
            />
          ) : (
            <NoCameraMode hasCameraPermission={hasCameraPermission} />
          )}
          {!frame && (
            <Box
              px="14px"
              width="100%"
              bg="rgba(0,0,0,0.2);"
              position="absolute"
              top="0"
              left="0"
            >
              {this.renderControllingPanel()}
            </Box>
          )}
        </FullScreen>

        <Flex
          flexDirection="column"
          alignItems="center"
          width="100vw"
          position="absolute"
          bottom="14px"
        >
          {noiseMeter && (
            <NoiseIndicator
              noiseMeter={noiseMeter}
              station="baby"
              colorFirstTwoDots={false}
            />
          )}
          <MonitoringStatus
            mt="16px"
            scheduler={scheduler}
            monitoringStartTime={monitoringStartTime}
            isConnected={isConnected}
            isMonitoring={isMonitoring}
          />
        </Flex>

        {remoteVideoStream && (
          <SeeMeMode
            frame={frame}
            remoteVideoStream={remoteVideoStream}
            onClose={stopVideoReceiving}
          />
        )}
        {motionSensitivity !== "MD_OFF" && (
          <MotionButton
            activity={activity}
            toggleMotionSettings={this.toggleMotionSettings}
            indicateMotion={indicateMotion}
            canDetectMotion={canDetectMotion}
          />
        )}
      </>
    );
  }
}

export default withFrame(Monitor);
